import { useState } from "react";
import { Link } from "@tanstack/react-router";
import { Menu, Phone, X, Mail } from "lucide-react";
import { nav, site } from "@/data/site";
import { Logo } from "./Logo";
import { trackConversion } from "@/lib/track";

export function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-background/95 backdrop-blur">
      <div className="bg-brand text-brand-foreground">
        <div className="container-page flex flex-wrap items-center justify-between gap-2 py-2 text-xs font-semibold sm:text-sm">
          <a href={site.emailHref} className="flex items-center gap-2 hover:underline">
            <Mail className="size-4" aria-hidden />
            {site.email}
          </a>
          <span className="hidden sm:inline">{site.hours}</span>
        </div>
      </div>

      <div className="border-b border-border">
        <div className="container-page flex items-center justify-between gap-4 py-3">
          <Logo />

          <nav className="hidden items-center gap-1 lg:flex" aria-label="Hoofdmenu">
            {nav.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="rounded-md px-3 py-2 text-sm font-semibold text-secondary transition hover:bg-accent hover:text-brand"
                activeProps={{ className: "text-brand bg-accent" }}
                activeOptions={{ exact: item.to === "/" }}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href={site.phoneHref}
      onClick={() => trackConversion("telefoon_klik")}
              className="hidden items-center gap-2 rounded-md border border-border px-3 py-2 text-sm font-bold text-secondary transition hover:border-brand hover:text-brand sm:flex"
            >
              <Phone className="size-4" aria-hidden />
              {site.phone}
            </a>
            <Link
              to="/offerte"
              className="hidden rounded-md bg-brand px-4 py-2.5 text-sm font-bold text-brand-foreground transition hover:bg-brand-dark sm:inline-block"
            >
              Offerte aanvragen
            </Link>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              className="grid size-10 place-items-center rounded-md border border-border text-secondary lg:hidden"
              aria-label={open ? "Menu sluiten" : "Menu openen"}
              aria-expanded={open}
            >
              {open ? <X className="size-5" aria-hidden /> : <Menu className="size-5" aria-hidden />}
            </button>
          </div>
        </div>
      </div>

      {open ? (
        <div className="border-b border-border bg-background lg:hidden">
          <nav className="container-page flex flex-col py-3" aria-label="Mobiel menu">
            {nav.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className="rounded-md px-2 py-3 font-semibold text-secondary"
                activeProps={{ className: "text-brand" }}
                activeOptions={{ exact: item.to === "/" }}
              >
                {item.label}
              </Link>
            ))}
            <div className="mt-3 grid gap-2">
              <a
                href={site.phoneHref}
      onClick={() => trackConversion("telefoon_klik")}
                className="rounded-md border border-border px-4 py-3 text-center font-bold text-secondary"
              >
                Bel {site.phone}
              </a>
              <Link
                to="/offerte"
                onClick={() => setOpen(false)}
                className="rounded-md bg-brand px-4 py-3 text-center font-bold text-brand-foreground"
              >
                Offerte aanvragen
              </Link>
            </div>
          </nav>
        </div>
      ) : null}
    </header>
  );
}
